import React, { useRef, useState } from "react";
import { useForm } from "react-hook-form";
import {
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  LinearProgress,
  Radio,
  RadioGroup,
} from "@mui/material";
import { yupResolver } from "@hookform/resolvers/yup";
import styled from "@emotion/styled";
import { TestSchema } from "./Schema";
import { useCountDown } from "../../../hooks/useCountDown";

const fleischmannV2MultiOptionQuestionId = {
  "Ingredientes Enriquecedores": 136,
};

const respuestasCorrectas = ["442", "443", "445", "446"];

export const TestFields = ({ question, handleResponse, last }) => {
  const TIEMPO_MAXIMO = 300;
  const normalise = (value) => ((value - 0) * 100) / (TIEMPO_MAXIMO - 0);
  let multiOption = false;

  if (
    question.idPregunta ==
    fleischmannV2MultiOptionQuestionId["Ingredientes Enriquecedores"]
  ) {
    multiOption = true;
  }

  // Opciones marcadas para la pregunta de seleccion multiple (hardcodeada)
  const [selected, setSelected] = useState([]);
  // Ref para que el envio por timeout lea la seleccion actual y no el closure viejo
  const selectedRef = useRef(selected);
  selectedRef.current = selected;

  const toggleOption = (idRespuesta) => {
    setSelected((prev) =>
      prev.includes(idRespuesta)
        ? prev.filter((id) => id !== idRespuesta)
        : [...prev, idRespuesta],
    );
  };

  const {
    getValues,
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "all", resolver: yupResolver(TestSchema) });

  const onSubmit = (data) => {
    if (multiOption) {
      // Una entrada por cada opcion marcada, con el mismo idPregunta
      const marcadas = selectedRef.current;
      const respuestas = marcadas.length
        ? marcadas.map((idRespuesta) => ({
            idPregunta: question?.idPregunta,
            idRespuesta,
          }))
        : [{ idPregunta: question?.idPregunta, idRespuesta: "0" }];
      const _respuestas = respuestas.map(({ idRespuesta }) => idRespuesta);
      const correctas = _respuestas.filter((respuesta) =>
        respuestasCorrectas.includes(respuesta),
      );

      if (
        respuestas.length === correctas.length &&
        correctas.length === respuestasCorrectas.length
      ) {
        handleResponse({
          idPregunta: question?.idPregunta,
          idRespuesta: "476",
        });
        setSelected([]);
        reset();
        return;
      }

      handleResponse({
          idPregunta: question?.idPregunta,
          idRespuesta: "0",
        })
      setSelected([]);
      reset();
      return;
    }
    const idRespuesta = getValues("idRespuesta");
    const respuesta = {
      idPregunta: question?.idPregunta,
      idRespuesta: idRespuesta || "0",
    };
    handleResponse(respuesta);
    reset();
  };
  const { counter } = useCountDown(TIEMPO_MAXIMO, onSubmit, question);
  return (
    <StyledForm onSubmit={handleSubmit(onSubmit)}>
      {multiOption ? (
        <FormGroup>
          {question?.respuestas
            .filter(({ respuesta }) => respuesta != "{{hidden}}")
            .map((value) => (
              <FormControlLabel
                key={value.idRespuesta}
                control={
                  <Checkbox
                    checked={selected.includes(value.idRespuesta)}
                    onChange={() => toggleOption(value.idRespuesta)}
                  />
                }
                label={value.respuesta}
              />
            ))}
        </FormGroup>
      ) : (
        <RadioGroup
          aria-labelledby="demo-radio-buttons-group-label"
          name="radio-buttons-group"
        >
          {question?.respuestas
            .filter(({ respuesta }) => respuesta != "{{hidden}}")
            .map((value) => (
              <FormControlLabel
                key={value.idRespuesta}
                {...register("idRespuesta")}
                value={value.idRespuesta}
                control={<Radio />}
                label={value.respuesta}
              />
            ))}
        </RadioGroup>
      )}
      <p>{errors?.idRespuesta?.message}</p>
      {multiOption ? (
        <StyledButton
          color="primary"
          type="button"
          variant="contained"
          onClick={onSubmit}
        >
          {last ? "Finalizar" : "Siguiente"}
        </StyledButton>
      ) : (
        <StyledButton color="primary" type="submit" variant="contained">
          {last ? "Finalizar" : "Siguiente"}
        </StyledButton>
      )}
      <LinearProgress
        variant="determinate"
        color="primary"
        value={normalise(counter)}
      />
    </StyledForm>
  );
};

const StyledForm = styled.form`
  display: flex;
  gap: 10px;
  flex-direction: column;
  p {
    font-size: 1rem;
    color: red;
  }
`;

export const StyledButton = styled(Button)`
  width: 100%;
  max-width: 300px;
  align-self: center;
`;
